import { createSvgIcon } from "@mui/material";

export const CodeWindowIcon = createSvgIcon(
  <svg
    width="46"
    height="41"
    viewBox="0 0 46 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12550_31816)">
      <path
        d="M18.1495 28.8201C17.9759 28.8201 17.8013 28.7598 17.6581 28.6371L12.7434 24.4098C12.5742 24.2641 12.4766 24.0503 12.4766 23.8257C12.4766 23.601 12.5742 23.3873 12.7434 23.2415L17.6581 19.0142C17.977 18.7392 18.4566 18.7786 18.7289 19.1008C19.0001 19.4241 18.9621 19.9075 18.6432 20.1826L14.4077 23.8257L18.6432 27.4687C18.9632 27.7438 19.0012 28.2283 18.7289 28.5505C18.5781 28.7291 18.3643 28.8201 18.1495 28.8201Z"
        fill="#2CAF2C"
      />
      <path
        d="M27.8504 28.8201C27.6356 28.8201 27.4219 28.728 27.2722 28.5505C26.9998 28.2283 27.0389 27.7438 27.3579 27.4687L31.5933 23.8257L27.3579 20.1826C27.0389 19.9086 26.9998 19.4241 27.2722 19.1008C27.5434 18.7786 28.024 18.7392 28.3419 19.0142L33.2565 23.2415C33.4257 23.3873 33.5234 23.601 33.5234 23.8257C33.5234 24.0503 33.4257 24.2641 33.2565 24.4098L28.3419 28.6371C28.1987 28.7598 28.024 28.8201 27.8504 28.8201Z"
        fill="#2CAF2C"
      />
      <path
        d="M21.26 31.9911C21.2079 31.9911 21.1558 31.9857 21.1027 31.9747C20.6926 31.887 20.43 31.4804 20.5157 31.0661L23.5784 16.3754C23.6652 15.9611 24.0677 15.6959 24.4778 15.7825C24.8879 15.8702 25.1504 16.2768 25.0647 16.6911L22.002 31.3818C21.9261 31.7434 21.6115 31.9911 21.26 31.9911Z"
        fill="#2CAF2C"
      />
      <path
        d="M40.9009 41H5.09906C2.28807 41 0 38.6896 0 35.8488V5.15117C0 2.31145 2.28807 0 5.09906 0H40.9009C43.7119 0 46 2.31145 46 5.15117V35.8488C46 38.6896 43.7119 41 40.9009 41ZM5.09906 1.53439C3.12453 1.53439 1.51887 3.15646 1.51887 5.15117V35.8488C1.51887 37.8435 3.12453 39.4656 5.09906 39.4656H40.9009C42.8755 39.4656 44.4811 37.8435 44.4811 35.8488V5.15117C44.4811 3.15646 42.8755 1.53439 40.9009 1.53439H5.09906Z"
        fill="#2CAF2C"
      />
      <path
        d="M45.2406 10.7834H0.759434C0.339575 10.7834 0 10.4404 0 10.0162C0 9.59207 0.339575 9.24902 0.759434 9.24902H45.2406C45.6604 9.24902 46 9.59317 46 10.0162C46 10.4393 45.6604 10.7834 45.2406 10.7834Z"
        fill="#2CAF2C"
      />
      <path
        d="M9.8128 7.03725C8.91666 7.03725 8.18652 6.29965 8.18652 5.39436C8.18652 4.48907 8.91666 3.75146 9.8128 3.75146C10.7089 3.75146 11.4391 4.48907 11.4391 5.39436C11.4391 6.29965 10.7089 7.03725 9.8128 7.03725Z"
        fill="#2CAF2C"
      />
      <path
        d="M4.81475 7.02114C3.91753 7.02114 3.18848 6.28354 3.18848 5.37824C3.18848 4.47295 3.91862 3.73535 4.81475 3.73535C5.71088 3.73535 6.44102 4.47295 6.44102 5.37824C6.44102 6.28354 5.71088 7.02114 4.81475 7.02114Z"
        fill="#2CAF2C"
      />
      <path
        d="M14.8113 7.05288C13.9152 7.05288 13.1851 6.31527 13.1851 5.40998C13.1851 4.50469 13.9152 3.76709 14.8113 3.76709C15.7075 3.76709 16.4376 4.50469 16.4376 5.40998C16.4376 6.31527 15.7075 7.05288 14.8113 7.05288Z"
        fill="#2CAF2C"
      />
    </g>
    <defs>
      <clipPath id="clip0_12550_31816">
        <rect width="46" height="41" fill="white" />
      </clipPath>
    </defs>
  </svg>,

  "Code Window Icon"
);
